import React, { Component } from "react"
import Modal from "react-modal"
import Button from "components/common/Button"

import Text from "components/text"
import ImagePlaceholder from "assets/images/imageplaceholder.png"

import "styles/components/common/upload-modal.scss"

export default class UploadPhotoModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photo: null,
      fileUrl: null,
    }

    this.inputFileRef = React.createRef()
  }

  closeModal = () => {
    const { onClose } = this.props

    if (onClose) {
      onClose()
    }
  }

  handleUpload = () => {
    const { onUpload } = this.props
    const { photo } = this.state

    if (onUpload) {
      onUpload(photo)
    }
  }

  handleImageClick = (e) => {
    e.preventDefault()
    this.inputFileRef.current.click()
  }

  handleChangeImage = (e) => {
    e.preventDefault()
    let file = e.target.files[0]
    let reader = new FileReader()

    if (file) {
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        this.setState({
          photo: file,
          fileUrl: [reader.result],
        })
      }
    }
  }

  render() {
    const {
      isOpen = false,
      errors,
      userProfile = {},
      isSubmitting,
    } = this.props
    const { fileUrl, photo } = this.state

    const imgUrl = (fileUrl ? fileUrl : userProfile.photo) || ImagePlaceholder

    return (
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        className="upload-modal"
        overlayClassName="upload-modal-overlay"
      >
        <div className="upload-modal-container">
          <span className="upload-modal-header" style={{ marginTop: 0 }}>
            Update Profile Photo
          </span>
          <div className="upload-modal-message">
            <div className="form-input -vertical -upload">
              <Text type="label" text="Profile" />
              <div className="form-image" onClick={this.handleImageClick}>
                <img
                  onError={(e) => (e.target.src = ImagePlaceholder)}
                  src={imgUrl}
                  alt="profile"
                />
              </div>
            </div>
            <div className="form-hint">Click the box above to upload.</div>
            {errors && <p className="error-message">{`* ${errors}`}</p>}
            <input
              accept=".png, .jpg, .jpeg"
              type="file"
              ref={this.inputFileRef}
              style={{ display: "none" }}
              onChange={this.handleChangeImage}
            />
          </div>
          <div className="actions">
            <Button label="Cancel" ghost={true} onClick={this.closeModal} />
            <Button
              label="Upload Photo"
              disabled={!photo || isSubmitting}
              onClick={this.handleUpload}
            />
          </div>
        </div>
      </Modal>
    )
  }
}
